import { render, staticRenderFns } from "./StudentGradeList.vue?vue&type=template&id=51c8594c&scoped=true"
import script from "./StudentGradeList.vue?vue&type=script&lang=js"
export * from "./StudentGradeList.vue?vue&type=script&lang=js"
import style0 from "./StudentGradeList.vue?vue&type=style&index=0&id=51c8594c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8594c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c8594c')) {
      api.createRecord('51c8594c', component.options)
    } else {
      api.reload('51c8594c', component.options)
    }
    module.hot.accept("./StudentGradeList.vue?vue&type=template&id=51c8594c&scoped=true", function () {
      api.rerender('51c8594c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentGrade/StudentGradeList.vue"
export default component.exports